import { IMPORT_SHOOP } from './actionsTypes';

export const importShoops = (importShoops) => {
  return {
    type: IMPORT_SHOOP,
    importShoops: importShoops,
    name: "Import"
  };
};
